import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import classes from "./KeyFeatures.module.css";
import { mergeClass } from "../../utils/helper";

export default function KeyFeatures({ data, onClick, loadingWithType }) {
  const isLoading =
    loadingWithType?.title?.toLowerCase() === data?.title?.toLowerCase();

  return (
    <Container fluid>
      <div className={classes.mainDiv}>
        <Row>
          <Col className="p-0" sm={5} md={4} lg={4} xl={3} xxl={3}>
            <div
              className={mergeClass(
                classes.titleDiv,
                classes[`${data?.variant}`],
                "pointerClass"
              )}
              onClick={() => {
                if (isLoading) return;
                onClick(data);
              }}
            >
              <span>{isLoading ? "Please Wait..." : data?.title}</span>
            </div>
          </Col>
          <Col sm={7} md={8} lg={8} xl={9} xxl={9}>
            <div className={classes.descriptionDiv}>
              <span>{data?.description}</span>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
}
